import { Card, Checkbox, Spinner, Typography } from '@sonnen/web-ui';
import { useEffect } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import { BatteryOptimizationCards } from '../../components/BatteryOptimizationCards/BatteryOptimizationCards';
import { OfferCalculationPage } from '../../components/OfferCalculationPage/OfferCalculationPage';
import { useTranslation } from '../../i18n/i18n';
import { OrderFlow } from '../../types';

const I18N_SCOPE = 'batteryOptimization';

export const BatteryOptimization = () => {
  const { t } = useTranslation();
  const { formValues, setFormValues, orderFlow, setOrderFlow } = useAppContext();
  const { confirmedDynamicTariff } = formValues;

  useEffect(() => {
    if (orderFlow !== OrderFlow.batteryOptimization) {
      setOrderFlow(OrderFlow.batteryOptimization);
    }
  }, [setOrderFlow, orderFlow]);

  if (orderFlow !== OrderFlow.batteryOptimization) {
    return <Spinner size="xl" accessibilityLabel={t('loadingUserDetails')} />;
  }

  return (
    <OfferCalculationPage dataTestId="battery-optimization" title={t(`${I18N_SCOPE}.title`)}>
      <Card className="gap" paddingSize="md">
        <Typography.H2>{t(`${I18N_SCOPE}.card1title`)}</Typography.H2>
        <Typography.Body1>{t(`${I18N_SCOPE}.card1text`)}</Typography.Body1>
        <Checkbox
          name="confirmedDynamicTariff"
          dataTestId="confirmed-dynamic-tariff"
          checked={confirmedDynamicTariff}
          clickableLabel
          onChange={() =>
            setFormValues({
              ...formValues,
              confirmedDynamicTariff: !confirmedDynamicTariff,
            })
          }
        >
          <Typography.Body1 variant={confirmedDynamicTariff ? 'success' : 'primary'}>
            <strong>{t(`${I18N_SCOPE}.confirmedDynamicTariff`)}</strong>
          </Typography.Body1>
        </Checkbox>
      </Card>

      <BatteryOptimizationCards />
    </OfferCalculationPage>
  );
};

export default BatteryOptimization;
